import {
  Stepper,
  Step,
  StepLabel,
  stepConnectorClasses,
  StepConnector,
  StepIconProps,
  styled,
  Box
} from '@mui/material';
import { Check, Person, Email, Work, Payment, VerifiedUser, LocalOffer, Verified, Help } from '@mui/icons-material';
import {steps} from './stepFormWrapper'

const QontoConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 10,
    left: 'calc(-50% + 16px)',
    right: 'calc(50% + 16px)',
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: theme.palette.primary.main,
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderColor: theme.palette.grey[300],
    borderTopWidth: 3,
    borderRadius: 1,
  },
}));

const StepIconRoot = styled('div')<{
  ownerState: { active: boolean; completed: boolean };
}>(({ theme, ownerState }) => ({
  backgroundColor: ownerState.completed ? theme.palette.primary.main : '#ccc',
  zIndex: 1,
  color: '#fff',
  width: 32,
  height: 32,
  display: 'flex',
  borderRadius: '50%',
  justifyContent: 'center',
  alignItems: 'center',
  boxShadow: ownerState.active ? `0 4px 10px 0 rgba(0,0,0,.25)` : 'none',
}));

function StepIconComponent(props: StepIconProps) {
  const { active, completed, className } = props;

  const icons: { [index: string]: React.ReactElement } = {
    1: <Person />,
    2: <Email />,
    3: <Work />,
    4: <Payment />,
    5: <LocalOffer />,
    6: <VerifiedUser />,
    7: <Verified />,
    8: <Help />,
    9: <Check />,
  };

  return (
    <StepIconRoot sx={{ backgroundColor: active ? "#FF6B2C" : "" }} ownerState={{ completed :!!completed, active:!!active }} className={className}>
      {icons[String(props.icon)]}
    </StepIconRoot>
  );
}

export const StepperNav = ({ activeStep }: { activeStep: number }) => {
  return (
    <Box sx={{ overflowX: 'auto' }}>
      <Stepper
        alternativeLabel
        activeStep={activeStep}
        connector={<QontoConnector />}
        sx={{ paddingY: 2, minWidth: '600px'}}

      >
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel StepIconComponent={StepIconComponent}>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
};
